/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailTrackingToggleResponse
 */
export interface EmailTrackingToggleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EmailTrackingToggleResponse
     */
    emailTrackingEnabled: boolean;
}

/**
 * Check if a given object implements the EmailTrackingToggleResponse interface.
 */
export function instanceOfEmailTrackingToggleResponse(value: object): value is EmailTrackingToggleResponse {
    if (!('emailTrackingEnabled' in value) || value['emailTrackingEnabled'] === undefined) return false;
    return true;
}

export function EmailTrackingToggleResponseFromJSON(json: any): EmailTrackingToggleResponse {
    return EmailTrackingToggleResponseFromJSONTyped(json, false);
}

export function EmailTrackingToggleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailTrackingToggleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'emailTrackingEnabled': json['email_tracking_enabled'],
    };
}

  export function EmailTrackingToggleResponseToJSON(json: any): EmailTrackingToggleResponse {
      return EmailTrackingToggleResponseToJSONTyped(json, false);
  }

  export function EmailTrackingToggleResponseToJSONTyped(value?: EmailTrackingToggleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email_tracking_enabled': value['emailTrackingEnabled'],
    };
}

